var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.cID)?_c('div',{class:['wishlist-btn', { active: _vm.inWishlist }]},[_c('button',{attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.updateWishlist()}}},[(_vm.wishlistLoading)?_c('Loading',{attrs:{"activated":true}}):_c('IconWishlist',{attrs:{"inWishlist":_vm.inWishlist}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }